import { GDSXModel, KVSXModel } from './../quy-trinh-san-xuat-model/quy-trinh-san-xuat.model';
import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { QuyTrinhSanXuatModel } from '../quy-trinh-san-xuat-model/quy-trinh-san-xuat.model';
const API_ROOT_URL = environment.ApiRoot + '/qtsx';
@Injectable()
export class QuyTrinhSanXuatService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	getListGiaiDoan(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/GDSX_LIST', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	addGiaiDoan(data: GDSXModel): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/GDSX_ADD_UPDATE', data, { headers: httpHeaders });
	}

	delGiaiDoan(Id: number){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+`/GDSX_DELETE?Id=${Id}`, { headers: httpHeaders });
	}

	getListCongDoan(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/CDSX_LIST', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	getListCongDoanTSKSTCDG(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/CDSX_LIST_TSKS_TCDG', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	addCongDoan(data: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/CDSX_ADD_UPDATE', data, { headers: httpHeaders });
	}

	delCongDoan(Id: number){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+`/CDSX_DELETE?Id=${Id}`, { headers: httpHeaders });
	}

	getListTSKS(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/THONGSOKIEMSOAT_LIST', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	addTSKS(data: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/THONGSOKIEMSOAT_ADD_UPDATE', data, { headers: httpHeaders });
	}

	delTSKS(Id: number){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+`/THONGSOKIEMSOAT_DELETE?Id=${Id}`, { headers: httpHeaders });
	}

	getListTCDG(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/TIEUCHIDANHGIA_LIST', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	addTCDG(data: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/TIEUCHIDANHGIA_ADD_UPDATE', data, { headers: httpHeaders });
	}

	delTCDG(Id: number){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+`/TIEUCHIDANHGIA_DELETE?Id=${Id}`, { headers: httpHeaders });
	}

	DM_PhongBan_Tree(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(environment.ApiRoot + '/danhmuc/DM_PhongBan_TheoCapCoCau', null , { headers: httpHeaders });
	}

	getListKVSX(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/KVSX_LIST', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	getListPXSX(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/PXSX_LIST', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	addKVSX(data: KVSXModel): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/KVSX_ADD_UPDATE', data, { headers: httpHeaders });
	}

	delKVSX(Id: number){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+`/KVSX_DELETE?Id=${Id}`, { headers: httpHeaders });
	}

	getListKVPXSX(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/KVSX_PXSX_LIST', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
}
